import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as reportActions from '../store/actions/report.actions';

@Injectable({
  providedIn: 'root',
})
export class ReportGuard {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(reportActions.loadData());
    return of(true);
  }
}
